<p-table
  #dt1
  [value]="nips"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. nip-a od ukupno {totalRecords}"
  [globalFilterFields]="[
    'batch',
    'request_nr',
    'product.name',
    'partner.company'
  ]"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-start">
      <div class="grid w-100">
        <div class="col-4">
          <span class="p-input-icon-left w-100 mb-2">
            <i class="pi pi-search"></i>
            <input
              name="fieldName"
              ngDefaultControl
              [(ngModel)]="globalSearchField"
              pInputText
              type="text"
              class="w-100"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Broj šarže, Broj zahteva, Ime proizvoda..."
            />
          </span>

          <p-columnFilter
            name="fieldName"
            ngDefaultControl
            [(ngModel)]="packageTypeSearchField"
            field="packaging_type"
            styleClass="w-100"
            matchMode="in"
            optionLabel="newproperty"
            [showMenu]="false"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template pTemplate="header">
              <div class="px-3 pt-3 p-0">
                <span class="text-bold">Izaberi tip</span>
              </div>
            </ng-template>
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="packageTypes"
                placeholder="Svi tipovi pakovanja"
                (onChange)="filter($event.value)"
                optionLabel="name"
              >
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="ml-1">{{ option?.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>

        <div class="col-4">
          <button
            class="clear-btn mb-2"
            (click)="clearFilters('rangeDates')"
            pTooltip="Obriši filter"
            tooltipPosition="top"
          >
            <i class="pi pi-times m-0"></i>
          </button>
          <button
            class="clear-btn"
            (click)="clearFilters('rangeDatesCreatedAt')"
            pTooltip="Obriši filter"
            tooltipPosition="top"
          >
            <i class="pi pi-times m-0"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-nip>
    <tr>
      <th pSortableColumn="id">
        <div class="flex justify-content-between align-items-center">
          Šarža br
          <!-- <p-sortIcon field="label"></p-sortIcon> -->
        </div>
      </th>
      <th>
        <span>Šifra proizvoda</span>
      </th>
      <th>
        <span>Naziv proizvoda</span>
      </th>

      <th>
        <span>Količina proizvoda</span>
      </th>
      <th>
        <span>Rok za izradu</span>
      </th>
      <th style="width: 8rem">Status</th>
      <th style="width: 8rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-nip>
    <tr [ngClass]="'nip-background-priority-' + nip?.priority">
      <td>
        {{ nip.batch }}
      </td>
      <td>
        <span>{{ nip.product?.label }}</span>
      </td>
      <td>
        <span>{{ nip.product?.name }}</span>
      </td>

      <td>
        <span>{{ nip.required_units }}</span>
      </td>
      <td>
        <span> {{ nip.deadline | date : "dd.MM.yyyy" }} </span>
      </td>
      <td>
        <span
          class="flex align-items-center"
          *ngIf="nip.active_time_tracker && !nip.active_time_tracker.end"
          style="color: #34d23a"
        >
          <i
            pTooltip="Merač vremena je trenutno aktivan"
            tooltipPosition="top"
            class="pi pi-clock mr-1"
          ></i
          >Aktivan
        </span>
        <span
          class="flex align-items-center"
          *ngIf="nip.active_time_tracker && nip.active_time_tracker.end"
          style="color: #ef4444"
        >
          <i
            pTooltip="Merač vremena je stopiran"
            tooltipPosition="top"
            class="pi pi-clock mr-1"
          ></i
          >Stopiran
        </span>
      </td>
      <td class="text-center">
        <section class="flex align-items-center justify-content-center">
          <a
            class="second-btn small-btn mr-2"
            pTooltip="Meri vreme"
            tooltipPosition="top"
            [routerLink]="['edit']"
            (click)="onEditNip(nip)"
          >
            <i class="pi pi-pencil"></i>
          </a>
        </section>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Ni jedan NIP nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
